import { API_BASE_URL } from "@/libs/apis/commons";

export const MINT_CHAIN_ID = process.env.NEXT_PUBLIC_MINT_CHAIN_ID ?? "80001";

export const POST_TOKEN_TRANSFER_URL = (
  contractAddress: string,
  tokenId: string,
) =>
  `${API_BASE_URL}/collections/${MINT_CHAIN_ID}/${contractAddress}/${tokenId}/init-transfer`;

export const GET_TOKEN_TRANSFER_STATUS_URL = (transactionId: string) =>
  `${API_BASE_URL}/collections/${transactionId}/transfer-status`;

export enum TokenTransferRequestFieldNames {
  chainId = "chainId",
  contractAddress = "contractAddress",
  tokenId = "tokenId",
  walletAddress = "destinationWalletAddress",
  legalAgreement = "legalAgreement",
  status = "status",
}
